import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CurrentMobile } from '@mri/types';
import { AuthResourceService } from '../auth-resource';
import { BaseResource } from '../base-resource';

@Injectable({
  providedIn: 'root'
})
export class CurrentMobileResourceService extends BaseResource<CurrentMobile>{

  constructor(
    http: HttpClient,
    authSrv: AuthResourceService
  ) {
    super({
      http, authSrv, baseUrl: 'mobiles/currents'
    })
  }

}
